import { FaCheck } from "react-icons/fa"

const SuccessIcon = () => {
    return (
        <div className="p-[100px] rounded-full bg-[#7dde7a]/10 max-w-[400px] mx-auto">
            <div className="p-[50px] rounded-full bg-[#7DDE7A]/30">
                <div className="w-[100px] aspect-square flex justify-center items-center rounded-full bg-[#32AC2E]">
                    <FaCheck className="text-6xl text-white" />
                </div>
            </div>
        </div>
    )
}

export default SuccessIcon